/* eslint-disable */
// @ts-nocheck

import * as reboot_api from "@reboot-dev/reboot-api";
import * as reboot_web from "@reboot-dev/reboot-web";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './store_pb.js'
//
// You can resolve this by passing --web-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  PresenceStore as PresenceStoreProto,
} from "./store_pb";
import * as store_pb from "./store_pb";
// Additionally re-export all messages_and_enums from the pb module.
export {
  PresenceIndicator,
  IdentifiedPresenceIndicator,
  UpdatePresenceRequest,
  UpdatePresenceResponse,
  GetPresenceRequest,
  GetPresenceResponse,
  ConnectRequest,
  ConnectResponse,
} from "./store_pb";

import * as protobuf_es from "@bufbuild/protobuf";

reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);



const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PresenceStoreUpdatePresenceRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.UpdatePresenceRequest>
): PresenceStore.UpdatePresenceRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.UpdatePresenceRequest
    ? partialRequest
    : store_pb.UpdatePresenceRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PresenceStoreUpdatePresenceRequestFromJsonString = (
  jsonRequest: string
): PresenceStore.UpdatePresenceRequest => {
  return PresenceStoreUpdatePresenceRequestFromProtobufShape(
    store_pb.UpdatePresenceRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PresenceStoreUpdatePresenceRequestToProtobuf = (
  partialRequest?: PresenceStore.PartialUpdatePresenceRequest
): store_pb.UpdatePresenceRequest => {
  return partialRequest instanceof store_pb.UpdatePresenceRequest
    ? partialRequest
    : new store_pb.UpdatePresenceRequest(
      partialRequest
    );
};

const PresenceStoreUpdatePresenceResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.UpdatePresenceResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.UpdatePresenceResponse
    ? partialResponse
    : store_pb.UpdatePresenceResponse.fromJson(partialResponse);

  return response;
};

const PresenceStoreUpdatePresenceResponseToProtobuf = (
  partialResponse?: PresenceStore.PartialUpdatePresenceResponse
): store_pb.UpdatePresenceResponse => {
  return partialResponse instanceof store_pb.UpdatePresenceResponse
    ? partialResponse
    : new store_pb.UpdatePresenceResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PresenceStoreGetPresenceRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.GetPresenceRequest>
): PresenceStore.GetPresenceRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.GetPresenceRequest
    ? partialRequest
    : store_pb.GetPresenceRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PresenceStoreGetPresenceRequestFromJsonString = (
  jsonRequest: string
): PresenceStore.GetPresenceRequest => {
  return PresenceStoreGetPresenceRequestFromProtobufShape(
    store_pb.GetPresenceRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PresenceStoreGetPresenceRequestToProtobuf = (
  partialRequest?: PresenceStore.PartialGetPresenceRequest
): store_pb.GetPresenceRequest => {
  return partialRequest instanceof store_pb.GetPresenceRequest
    ? partialRequest
    : new store_pb.GetPresenceRequest(
      partialRequest
    );
};

const PresenceStoreGetPresenceResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.GetPresenceResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.GetPresenceResponse
    ? partialResponse
    : store_pb.GetPresenceResponse.fromJson(partialResponse);

  return response;
};

const PresenceStoreGetPresenceResponseToProtobuf = (
  partialResponse?: PresenceStore.PartialGetPresenceResponse
): store_pb.GetPresenceResponse => {
  return partialResponse instanceof store_pb.GetPresenceResponse
    ? partialResponse
    : new store_pb.GetPresenceResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PresenceStoreConnectRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.ConnectRequest>
): PresenceStore.ConnectRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.ConnectRequest
    ? partialRequest
    : store_pb.ConnectRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PresenceStoreConnectRequestFromJsonString = (
  jsonRequest: string
): PresenceStore.ConnectRequest => {
  return PresenceStoreConnectRequestFromProtobufShape(
    store_pb.ConnectRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PresenceStoreConnectRequestToProtobuf = (
  partialRequest?: PresenceStore.PartialConnectRequest
): store_pb.ConnectRequest => {
  return partialRequest instanceof store_pb.ConnectRequest
    ? partialRequest
    : new store_pb.ConnectRequest(
      partialRequest
    );
};

const PresenceStoreConnectResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.ConnectResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.ConnectResponse
    ? partialResponse
    : store_pb.ConnectResponse.fromJson(partialResponse);

  return response;
};

const PresenceStoreConnectResponseToProtobuf = (
  partialResponse?: PresenceStore.PartialConnectResponse
): store_pb.ConnectResponse => {
  return partialResponse instanceof store_pb.ConnectResponse
    ? partialResponse
    : new store_pb.ConnectResponse(
      partialResponse
    );
};



export namespace PresenceStore {
  export type UpdatePresenceRequest =
    store_pb.UpdatePresenceRequest;

  export type PartialUpdatePresenceRequest =
  protobuf_es.PartialMessage<store_pb.UpdatePresenceRequest>;

  export type UpdatePresenceResponse =
    store_pb.UpdatePresenceResponse;

  export type PartialUpdatePresenceResponse =
  protobuf_es.PartialMessage<store_pb.UpdatePresenceResponse>;
}
export namespace PresenceStore {
  export type GetPresenceRequest =
    store_pb.GetPresenceRequest;

  export type PartialGetPresenceRequest =
  protobuf_es.PartialMessage<store_pb.GetPresenceRequest>;

  export type GetPresenceResponse =
    store_pb.GetPresenceResponse;

  export type PartialGetPresenceResponse =
  protobuf_es.PartialMessage<store_pb.GetPresenceResponse>;
}
export namespace PresenceStore {
  export type ConnectRequest =
    store_pb.ConnectRequest;

  export type PartialConnectRequest =
  protobuf_es.PartialMessage<store_pb.ConnectRequest>;

  export type ConnectResponse =
    store_pb.ConnectResponse;

  export type PartialConnectResponse =
  protobuf_es.PartialMessage<store_pb.ConnectResponse>;
}



const PRESENCE_STORE_UPDATE_PRESENCE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PresenceStoreUpdatePresenceAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PRESENCE_STORE_UPDATE_PRESENCE_ERROR_TYPES
  >[number];

export class PresenceStoreUpdatePresenceAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PRESENCE_STORE_UPDATE_PRESENCE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PresenceStoreUpdatePresenceAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PresenceStoreUpdatePresenceAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PresenceStoreUpdatePresenceAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PresenceStoreUpdatePresenceAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const PRESENCE_STORE_GET_PRESENCE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PresenceStoreGetPresenceAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PRESENCE_STORE_GET_PRESENCE_ERROR_TYPES
  >[number];

export class PresenceStoreGetPresenceAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PRESENCE_STORE_GET_PRESENCE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PresenceStoreGetPresenceAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PresenceStoreGetPresenceAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PresenceStoreGetPresenceAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PresenceStoreGetPresenceAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const PRESENCE_STORE_CONNECT_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PresenceStoreConnectAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PRESENCE_STORE_CONNECT_ERROR_TYPES
  >[number];

export class PresenceStoreConnectAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PRESENCE_STORE_CONNECT_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PresenceStoreConnectAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PresenceStoreConnectAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PresenceStoreConnectAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PresenceStoreConnectAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


class _Reactively {
  #id: string;
  #state: string;

  constructor(id: string, options?: reboot_api.CallOptions) {
    this.#id = id;
    this.#state = "dev.moment.presence.v1alpha1.PresenceStore";
  }

  async getPresence(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialGetPresenceRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<PresenceStore.GetPresenceResponse, void, unknown>,
      (newRequest: PresenceStore.PartialGetPresenceRequest) => void
    ]> {
    const request = PresenceStoreGetPresenceRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "GetPresence",
        id: this.#id,
        requestType: store_pb.GetPresenceRequest,
        responseType: store_pb.GetPresenceResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
        websockets: context.websockets,
      }
    );

    const setTypedRequest = (newRequest: PresenceStore.PartialGetPresenceRequest): void => {
      const typedRequest = PresenceStoreGetPresenceRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<PresenceStore.GetPresenceResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = PresenceStoreGetPresenceResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async connect(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialConnectRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<PresenceStore.ConnectResponse, void, unknown>,
      (newRequest: PresenceStore.PartialConnectRequest) => void
    ]> {
    const request = PresenceStoreConnectRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "Connect",
        id: this.#id,
        requestType: store_pb.ConnectRequest,
        responseType: store_pb.ConnectResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
        websockets: context.websockets,
      }
    );

    const setTypedRequest = (newRequest: PresenceStore.PartialConnectRequest): void => {
      const typedRequest = PresenceStoreConnectRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<PresenceStore.ConnectResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = PresenceStoreConnectResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

}

class _Idempotently {
  #stateRef: string;
  #idempotencyKey: string;

  constructor(id: string, idempotencyKey: string, options?: reboot_api.CallOptions) {
    this.#stateRef = reboot_api.stateIdToRef("dev.moment.presence.v1alpha1.PresenceStore", id);
    this.#idempotencyKey = idempotencyKey;
  }

  async updatePresence(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialUpdatePresenceRequest,
    options?: { signal?: AbortSignal },
  ): Promise<PresenceStore.UpdatePresenceResponse> {
    const request = PresenceStoreUpdatePresenceRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.presence.v1alpha1.PresenceStoreMethods/UpdatePresence",
        stateRef: this.#stateRef,
        requestType: store_pb.UpdatePresenceRequest,
        responseType: store_pb.UpdatePresenceResponse,
        abortedType: PresenceStoreUpdatePresenceAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return PresenceStoreUpdatePresenceResponseFromProtobufShape(responseProtobuf);
  }

}

export class PresenceStoreWeakReference {
  #id: string;
  #options?: reboot_api.CallOptions;

  constructor(id: string) {
    this.#id = id;
  }

  get stateId(): string {
    return this.#id;
  }

  public reactively() {
    return new _Reactively(
      this.#id,
    );
  }

  public idempotently({ key }: { key: string }) {
    return new _Idempotently(
      this.#id,
      key,
    );
  }


  async updatePresence(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialUpdatePresenceRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PresenceStore.UpdatePresenceResponse> {

    const request = PresenceStoreUpdatePresenceRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.presence.v1alpha1.PresenceStore",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.presence.v1alpha1.PresenceStoreMethods/UpdatePresence",
        stateRef: stateRef,
        requestType: store_pb.UpdatePresenceRequest,
        responseType: store_pb.UpdatePresenceResponse,
        abortedType: PresenceStoreUpdatePresenceAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PresenceStoreUpdatePresenceResponseFromProtobufShape(protobufResponse);
  }


  async getPresence(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialGetPresenceRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PresenceStore.GetPresenceResponse> {

    const request = PresenceStoreGetPresenceRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.presence.v1alpha1.PresenceStore",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.presence.v1alpha1.PresenceStoreMethods/GetPresence",
        stateRef: stateRef,
        requestType: store_pb.GetPresenceRequest,
        responseType: store_pb.GetPresenceResponse,
        abortedType: PresenceStoreGetPresenceAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PresenceStoreGetPresenceResponseFromProtobufShape(protobufResponse);
  }


  async connect(
    context: reboot_web.WebContext,
    partialRequest?: PresenceStore.PartialConnectRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PresenceStore.ConnectResponse> {

    const request = PresenceStoreConnectRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.presence.v1alpha1.PresenceStore",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.presence.v1alpha1.PresenceStoreMethods/Connect",
        stateRef: stateRef,
        requestType: store_pb.ConnectRequest,
        responseType: store_pb.ConnectResponse,
        abortedType: PresenceStoreConnectAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PresenceStoreConnectResponseFromProtobufShape(protobufResponse);
  }

}

export class PresenceStore {

  static WeakReference = PresenceStoreWeakReference;

  public static ref(
    id: string,
    options?: { bearerToken?: string }
  ) {
    return new PresenceStore.WeakReference(id, options?.bearerToken);
  }



}

export namespace PresenceStore {
  export type WeakReference = typeof PresenceStore.WeakReference.prototype;
}

